import Vue from 'vue'
import VueI18n from 'vue-i18n'

import stkf from './stkf'
import wff from './wff'

Vue.use(VueI18n)

const locale = process.env.VUE_APP_NAME || 'stkf'
const fallbackLocale = 'stkf'

const i18n = new VueI18n({
  locale,
  fallbackLocale,
  messages: {
    stkf,
    wff
  },
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  missing: (locale, key, vm) => {
    // Try to extract a readable text from the key as fallback
    const keyParts = key.split('.')
    const lastPart = keyParts[keyParts.length - 1]
    // Convert snake_case or camelCase to readable text
    const readable = lastPart
      .replace(/_/g, ' ')
      .replace(/([A-Z])/g, ' $1')
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
    return readable
  }
})

export default i18n
